import { render, staticRenderFns } from "./CustomerTripOrdersDetail.vue?vue&type=template&id=027dc2ed&scoped=true"
import script from "./CustomerTripOrdersDetail.vue?vue&type=script&lang=js"
export * from "./CustomerTripOrdersDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerTripOrdersDetail.vue?vue&type=style&index=0&id=027dc2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027dc2ed",
  null
  
)

export default component.exports